// extracted by mini-css-extract-plugin
module.exports = {"headline":"EditProjectHeadline_headline__312YA","cancel":"EditProjectHeadline_cancel__2vqXR","btns":"EditProjectHeadline_btns__O6KPd","fade":"EditProjectHeadline_fade__ZIhaA"};